import api from "@/lib/api";

const MAX_VIDEO = 1024 * 1024 * 1024;
const MAX_IMAGE = 30 * 1024 * 1024;

async function withRetry(fn, tries = 4) {
  let last;
  for (let i = 0; i < tries; i++) {
    try {
      return await fn();
    } catch (e) {
      last = e;
      const status = e.response?.status;
      if (status && status < 500 && status !== 408 && status !== 429) throw e;
      await new Promise((r) => setTimeout(r, 1000 * 2 ** i));
    }
  }
  throw last;
}

// Uploads a file in 8MB parts so large videos (up to 1 GB) don't hit proxy limits.
export async function uploadMediaChunked(file, onProgress) {
  const isImage = (file.type || "").startsWith("image/");
  if (file.size > (isImage ? MAX_IMAGE : MAX_VIDEO)) {
    const err = new Error(isImage ? "Imagem muito grande (máx. 30 MB)." : "Vídeo muito grande (máx. 1 GB).");
    err.friendly = true;
    throw err;
  }
  const { data: init } = await api.post("/upload/init", { filename: file.name, size: file.size });
  const { upload_id, chunk_size, total_chunks } = init;
  for (let i = 0; i < total_chunks; i++) {
    const blob = file.slice(i * chunk_size, Math.min(file.size, (i + 1) * chunk_size));
    await withRetry(() =>
      api.put(`/upload/${upload_id}/chunk/${i}`, blob, {
        headers: { "Content-Type": "application/octet-stream" },
        timeout: 120000,
      })
    );
    if (onProgress) onProgress(Math.round(((i + 1) / total_chunks) * 100));
  }
  const { data } = await withRetry(() => api.post(`/upload/${upload_id}/complete`));
  return data;
}
